export enum MIME_TYPES {
  jpg = 'image/jpeg',
  pjpg = 'image/pjpeg',
  gif = 'image/gif',
  png = 'image/png',
  bmp = 'image/bmp',
  tiff = 'image/tiff',
  txt = 'text/plain',
  csv = 'text/comma-separated-values',
  xls = 'application/msexcel',
  xlsx = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  doc = 'application/msword',
  docx = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  pdf = 'application/pdf',
  svg = 'image/svg+xml'
}

export const DEFAULT_FILE_SIZE = 5242880; // 5mb in bytes

const FILE_TYPE = {
  [MIME_TYPES.jpg]: 'JPG',
  [MIME_TYPES.pjpg]: 'JPEG',
  [MIME_TYPES.gif]: 'GIF',
  [MIME_TYPES.png]: 'PNG',
  [MIME_TYPES.bmp]: 'BMP',
  [MIME_TYPES.tiff]: 'TIFF',
  [MIME_TYPES.txt]: 'TXT',
  [MIME_TYPES.csv]: 'CSV',
  [MIME_TYPES.xls]: 'XLS',
  [MIME_TYPES.xlsx]: 'XLSx',
  [MIME_TYPES.doc]: 'DOC',
  [MIME_TYPES.docx]: 'DOCx',
  [MIME_TYPES.pdf]: 'PDF',
  [MIME_TYPES.svg]: 'SVG',
};

const FILE_TYPE_TO_MIME = {
  'JPG': MIME_TYPES.jpg,
  'JPEG': MIME_TYPES.pjpg,
  'GIF': MIME_TYPES.gif,
  'PNG': MIME_TYPES.png,
  'BMP': MIME_TYPES.bmp,
  'TIFF': MIME_TYPES.tiff,
  'TXT': MIME_TYPES.txt,
  'CSV': MIME_TYPES.csv,
  'XLS': MIME_TYPES.xls,
  'XLSx': MIME_TYPES.xlsx,
  'DOC': MIME_TYPES.doc,
  'DOCx': MIME_TYPES.docx,
  'PDF': MIME_TYPES.pdf,
  'SVG': MIME_TYPES.svg
};

export { FILE_TYPE, FILE_TYPE_TO_MIME };
